export function setBasePersonName( name ){
    return {
        type: "SET_BASE_PERSON_NAME",
        payload: name
    }
}

export function setBasePersonEmail( email ){
    return {
        type: "SET_BASE_PERSON_EMAIL",
        payload: email
    }
}

export function setBasePersonPhoneNumber( phoneNumber ){
    return {
        type: "SET_BASE_PERSON_PHONE_NUMBER",
        payload: phoneNumber
    }
}
export function setPersonType(type) {
	return {
		type: "SET_PERSON_TYPE",
		payload: type
	}
}
export function setPersonDoc(doc) {
	return {
		type: "SET_PERSON_DOC",
		payload: doc
	}
}



// WEBPACK FOOTER //
// ./src/components/parts/person/actions.js